(function () {
  const p = window.VIRUS_PRODUCT;
  const shop = (window.VIRUS_SHOP && window.VIRUS_SHOP.domain) || "wearvirus.com";
  const state = { size: "M", qty: 1, shot: 0 };

  function byId(id) { return document.getElementById(id); }

  function toast(msg) {
    const el = byId("toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("show");
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.classList.remove("show"); }, 2000);
  }

  function variant() {
    return p.variants.find(function (v) { return v.size === state.size; }) || p.variants[1];
  }

  function paintShot() {
    const shot = p.shots[state.shot];
    const img = byId("mainShot");
    const cap = byId("shotCap");
    if (img) img.src = shot.src;
    if (cap) cap.textContent = shot.caption;
    document.querySelectorAll("#thumbs button").forEach(function (btn, i) {
      btn.classList.toggle("on", i === state.shot);
    });
  }

  function paintBuy() {
    document.querySelectorAll("#sizes button").forEach(function (btn) {
      btn.classList.toggle("on", btn.getAttribute("data-size") === state.size);
    });
    const qty = byId("qty");
    if (qty) qty.textContent = String(state.qty);
    const buy = byId("buyBtn");
    if (buy) {
      const total = ((p.price * state.qty) / 100).toFixed(2);
      buy.textContent = "INFECT — $" + total;
    }
  }

  function checkout() {
    const v = variant();
    if (!v) return toast("size missing");
    const form = byId("shopifyAdd");
    if (form) {
      const id = form.querySelector('[name="id"]');
      const qty = form.querySelector('[name="quantity"]');
      if (id) id.value = v.id;
      if (qty) qty.value = String(state.qty);
      form.submit();
      return;
    }
    window.location.href = "https://" + shop + "/cart/" + v.id + ":" + state.qty;
  }

  function boot() {
    const thumbs = byId("thumbs");
    if (thumbs) {
      thumbs.innerHTML = p.shots.map(function (s, i) {
        return '<button type="button" data-i="' + i + '" class="' + (i === 0 ? "on" : "") + '"><img src="' + s.src + '" alt=""></button>';
      }).join("");
      thumbs.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          state.shot = Number(btn.getAttribute("data-i"));
          paintShot();
        });
      });
    }

    const sizes = byId("sizes");
    if (sizes) {
      sizes.innerHTML = p.variants.map(function (v) {
        return '<button type="button" data-size="' + v.size + '">' + v.size + "</button>";
      }).join("");
      sizes.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          state.size = btn.getAttribute("data-size");
          paintBuy();
        });
      });
    }

    if (byId("qtyMinus")) {
      byId("qtyMinus").addEventListener("click", function () {
        state.qty = Math.max(1, state.qty - 1);
        paintBuy();
      });
    }
    if (byId("qtyPlus")) {
      byId("qtyPlus").addEventListener("click", function () {
        state.qty = Math.min(10, state.qty + 1);
        paintBuy();
      });
    }
    if (byId("buyBtn")) byId("buyBtn").addEventListener("click", checkout);

    const ticker = byId("ticker");
    if (ticker) ticker.innerHTML += ticker.innerHTML;

    const ascii = document.querySelector(".ascii");
    if (ascii) {
      setInterval(function () {
        if (Math.random() > 0.2) return;
        ascii.classList.add("shake");
        setTimeout(function () { ascii.classList.remove("shake"); }, 360);
      }, 4200);
    }

    paintShot();
    paintBuy();
  }

  document.addEventListener("DOMContentLoaded", boot);
})();
